import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import winedancersImage from "./Images/WineDancers.png";
import "./App.css";

const EOIContainer = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 0 2rem 0 2rem;
  background-color: #f5e9dd;
`;

const EOIWrapper = styled.div`
  background-color: rgb(255, 246, 237);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 1px solid #1b3619;
  border-image: url("data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3cfilter id='noiseFilter'%3e%3cfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='4' stitchTiles='stitch'/%3e%3c/filter%3e%3crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3e%3c/svg%3e")
    1;
  border-style: solid;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

const TitleImage = styled.img`
  max-width: 150px;
  height: auto;
  margin-bottom: 1rem;
  flex-shrink: 0;
`;

const EOITitle = styled.h1`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 6vmin;
  text-align: center;
  margin-bottom: 1rem;
  margin-top: 0;
  flex-shrink: 0;
`;

const EOISubtitle = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  line-height: 1.4;
`;

const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  flex: 1;
`;

const FormSection = styled.div`
  margin-bottom: 2rem;
  text-align: left;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  margin-bottom: 0.4rem;
  font-weight: 400;
`;

const Input = styled.input`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid rgba(139, 121, 94, 0.3);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);

  &:focus {
    outline: none;
    border-color: #1c4587;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(27, 54, 25, 0.1),
      0 3px 8px rgba(139, 121, 94, 0.15);
    transform: translateY(-1px);
  }

  &:hover:not(:focus) {
    border-color: rgba(139, 121, 94, 0.5);
    background: rgba(255, 255, 255, 0.9);
  }

  &::placeholder {
    color: rgba(27, 54, 25, 0.5);
    font-style: italic;
    font-size: 0.8rem;
  }
`;

const TextArea = styled.textarea`
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid rgba(139, 121, 94, 0.3);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  resize: vertical;
  min-height: 80px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  line-height: 1.4;

  &:focus {
    outline: none;
    border-color: #1c4587;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(27, 54, 25, 0.1),
      0 3px 8px rgba(139, 121, 94, 0.15);
    transform: translateY(-1px);
  }

  &:hover:not(:focus) {
    border-color: rgba(139, 121, 94, 0.5);
    background: rgba(255, 255, 255, 0.9);
  }

  &::placeholder {
    color: rgba(27, 54, 25, 0.5);
    font-style: italic;
    font-size: 0.8rem;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.5rem;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  cursor: pointer;

  input {
    margin-right: 0.75rem;
    transform: scale(1.2);
  }
`;

const CheckboxGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-top: 0.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const CheckboxOption = styled.label`
  display: flex;
  align-items: center;
  font-family: "IM Fell English", serif;
  font-size: 0.9rem;
  cursor: pointer;

  input {
    margin-right: 0.75rem;
    transform: scale(1.2);
  }
`;

const SubmitButton = styled.button`
  background-color: transparent;
  border: 1px solid #1c4587;
  transition: all 0.3s ease-in-out;
  font-family: "Monsieur La Doulaise", cursive;
  font-weight: 400;
  font-style: normal;
  font-size: 1.1rem;
  text-align: center;
  padding: 0.75rem 2rem;
  color: #1c4587;
  cursor: pointer;
  border-radius: 6px;
  max-width: 350px;
  margin: 2rem auto 0;
  display: block;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;

  &:hover:not(:disabled) {
    background-color: #1c4587;
    color: #fef6ec;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(27, 54, 25, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const StyledLink = styled(Link)`
  color: #1c4587;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #1c4587;
  }
`;

const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 2rem;

  h2 {
    font-family: "Monsieur La Doulaise", cursive;
    font-size: 4rem;
    margin-bottom: 1rem;
  }

  p {
    font-family: "IM Fell English", serif;
    font-size: 1.2rem;
    line-height: 1.6;
  }

  .checkmark {
    font-size: 4rem;
    margin-bottom: 1rem;
  }
`;

const ExpressionOfInterest = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    attendanceInterest: "",
    activityInterests: [],
    specialMessage: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleActivityChange = (activity, checked) => {
    setFormData((prev) => ({
      ...prev,
      activityInterests: checked
        ? [...prev.activityInterests, activity]
        : prev.activityInterests.filter((item) => item !== activity),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "wedding-rsvps"), {
        ...formData,
        timestamp: serverTimestamp(),
        submittedAt: new Date().toISOString(),
      });
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error submitting expression of interest:", error);
      alert(
        "Sorry, there was an error submitting your response. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <EOIContainer>
        <EOIWrapper>
          <SuccessMessage>
            <h2>Thank You!</h2>
            <p>
              Your expression of interest has been received successfully. We'll
              be in touch soon with more details about our Tuscan celebration!
            </p>
          </SuccessMessage>
        </EOIWrapper>
      </EOIContainer>
    );
  }

  return (
    <EOIContainer>
      <EOIWrapper>
        <TitleImage
          src={winedancersImage}
          alt="Wine Dancers"
          loaded={imageLoaded}
          onLoad={() => setImageLoaded(true)}
        />
        <EOITitle>Expression of Interest</EOITitle>
        <EOISubtitle>
          Help us plan our perfect celebration by letting us know your initial
          thoughts about joining us in Tuscany!
          <p>Please respond by September 2025.</p>
        </EOISubtitle>

        <FormContainer>
          <form onSubmit={handleSubmit}>
            <FormSection>
              <FormRow>
                <FormField>
                  <Label htmlFor="name">Full Name *</Label>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </FormField>
                <FormField>
                  <Label htmlFor="email">Email Address *</Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </FormField>
              </FormRow>

              <FormField>
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </FormField>
            </FormSection>

            <FormSection>
              <Label>Attendance Interest *</Label>
              <RadioGroup>
                <RadioOption>
                  <input
                    type="radio"
                    name="attendanceInterest"
                    value="full-week"
                    checked={formData.attendanceInterest === "full-week"}
                    onChange={handleInputChange}
                    required
                  />
                  Interested in attending for the full week
                </RadioOption>
                <RadioOption>
                  <input
                    type="radio"
                    name="attendanceInterest"
                    value="some-days"
                    checked={formData.attendanceInterest === "some-days"}
                    onChange={handleInputChange}
                    required
                  />
                  Interested in attending for some days
                </RadioOption>
                <RadioOption>
                  <input
                    type="radio"
                    name="attendanceInterest"
                    value="ceremony-only"
                    checked={formData.attendanceInterest === "ceremony-only"}
                    onChange={handleInputChange}
                    required
                  />
                  Interested in ceremony and reception only
                </RadioOption>
                <RadioOption>
                  <input
                    type="radio"
                    name="attendanceInterest"
                    value="cannot-attend"
                    checked={formData.attendanceInterest === "cannot-attend"}
                    onChange={handleInputChange}
                    required
                  />
                  Unfortunately cannot attend
                </RadioOption>
              </RadioGroup>
            </FormSection>

            <FormSection
              style={{
                visibility:
                  formData.attendanceInterest !== "cannot-attend"
                    ? "visible"
                    : "hidden",
                height:
                  formData.attendanceInterest !== "cannot-attend"
                    ? "auto"
                    : "0",
                marginBottom:
                  formData.attendanceInterest !== "cannot-attend"
                    ? "2rem"
                    : "0",
                overflow: "visible",
              }}
            >
              <Label>Activity Interests (check all that apply)</Label>
              <CheckboxGroup>
                {[
                  "Wine Tastings",
                  "Cooking Classes",
                  "Cultural Tours",
                  "Florence Day Trip",
                  "Outdoor Activities",
                  "Art & Museums",
                ].map((activity) => (
                  <CheckboxOption key={activity}>
                    <input
                      type="checkbox"
                      checked={formData.activityInterests.includes(activity)}
                      onChange={(e) =>
                        handleActivityChange(activity, e.target.checked)
                      }
                      disabled={formData.attendanceInterest === "cannot-attend"}
                    />
                    {activity}
                  </CheckboxOption>
                ))}
              </CheckboxGroup>
            </FormSection>

            <FormSection>
              <FormField>
                <Label htmlFor="specialMessage">Special Message</Label>
                <TextArea
                  id="specialMessage"
                  name="specialMessage"
                  value={formData.specialMessage}
                  onChange={handleInputChange}
                  placeholder="Any questions, thoughts, or excitement you'd like to share..."
                />
              </FormField>
            </FormSection>

            <SubmitButton type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </SubmitButton>
          </form>
        </FormContainer>
      </EOIWrapper>
    </EOIContainer>
  );
};

export default ExpressionOfInterest;
